import { render } from "./team.vue?vue&type=template&id=adc8392e&scoped=true"
import script from "./team.vue?vue&type=script&lang=js"
export * from "./team.vue?vue&type=script&lang=js"

import "./team.vue?vue&type=style&index=0&id=adc8392e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-adc8392e"

export default script